import { Action, Comment, CommentsResponse, Product, Reply, User } from '../types';

export const GET_COMMENTS = 'GET_COMMENTS';
export const SET_COMMENTS = 'SET_COMMENTS';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const ADD_REPLY = 'ADD_REPLY';
export const REMOVE_REPLY = 'REMOVE_REPLY';
export const SELECT_COMMENT = 'SELECT_COMMENT';
export const SET_PRODUCT_INFO = 'SET_PRODUCT_INFO';
export const SET_WIDGET_ID = 'SET_WIDGET_ID';
export const SET_META_TAGS = 'SET_META_TAGS';
export const SET_THEME_MODE = 'SET_THEME_MODE';
export const HIDE_WIDGET = 'HIDE_WIDGET';
export const OPEN_USER_FORM = 'OPEN_USER_FORM';
export const CLOSE_USER_FORM = 'CLOSE_USER_FORM';

export const getCommentsAction = () : Action => ({
    type: GET_COMMENTS,
})
export const setComments = (payload: CommentsResponse): Action => ({
  type: SET_COMMENTS,
  payload,
});

export const addComment = (payload: Comment): Action => ({
  type: ADD_COMMENT,
  payload,
});

export const removeComment = (payload: number): Action => ({
  type: REMOVE_COMMENT,
  payload,
});

export const addReply = (payload: { commentId: number; reply: Reply }): Action => ({
  type: ADD_REPLY,
  payload,
});

export const removeReply = (payload: { commentId: number; replyId: number }): Action => ({
  type: REMOVE_REPLY,
  payload,
});

export const selectComment = (payload: {commentId: number | string; }): Action => ({
    type: SELECT_COMMENT,
    payload,
});

export const setProductInfo = (payload: { product: Product }): Action => ({
    type: SET_PRODUCT_INFO,
    payload,
});

export const setWidgetId = (payload: { widgetId: string | undefined | null  }): Action => ({
    type: SET_WIDGET_ID,
    payload,
});

export const setMetaTags = (payload: { [key: string]: string}): Action => ({
    type: SET_META_TAGS,
    payload
})

export const setThemeMode = (payload: { mode: string }): Action => ({
    type: SET_THEME_MODE,
    payload
})

export const hideWidget = () => ({
  type: HIDE_WIDGET,
})

export const openUserForm = (payload: {
  commentText?: string;
  label?: string;
  additionalPayload?: Record<string, unknown>;
  onSuccess?: (user: Partial<User>, additionalPayload: Record<string, unknown>) => void;
  onClose?: () => void;
}): Action => ({
  type: OPEN_USER_FORM,
  payload: {
    ...payload,
    onSuccess: payload.onSuccess
      ? (user: Partial<User>) => payload.onSuccess?.(user, payload.additionalPayload || {})
      : undefined,
  },
});

export const closeUserForm = (): Action => ({
  type: CLOSE_USER_FORM
});